export default __webpack_public_path__ + "63307ad3d4102aec790ac7470f084669.jpg";